@if (event.overdue > 0) {
  <div class="overdue-label"></div>
}

<div class="eventDescription">
  <div class="eventTime">
    {{ event.StartTime | moment: 'HH:mm' }} -
    {{ event.EndTime | moment: 'HH:mm' }}
  </div>
  <app-calendar-event-icons [event]="event"></app-calendar-event-icons>
</div>

@if (event.postcode) {
  <div class="eventPostCode">
    {{ event.postcode }}
  </div>
}

@if (event.IsReminder) {
  <div
    class="eventProjectStatus"
    style="
      display: inline-block;
      background: linear-gradient(
        0deg,
        rgba(0, 0, 0, 0.2) 50%,
        rgba(0, 0, 0, 0.4) 100%
      );
      border-radius: 3px;
      padding: 0px 6px;
      margin: 4px 0px 0px 6px;
      font-size: 12px;
      color: #fff;
      box-shadow: 0 1px 0px 0 rgb(255 255 255 / 20%);
    "
  >
    Reminder Event
  </div>
}

@if (event.billingContactName) {
  <div class="eventBilling">
    @if (event.customerCompanyName?.length > 2) {
      {{ event.customerCompanyName }} -
    }
    {{ event.billingContactName }}
  </div>
}

@if ((event.projectStatus || event.financialStatus) && !event.IsReminder) {
  <div class="eventProjectStatus">
    @if (event.projectStatus) {
      {{ event.projectStatus }}
    }

    @if (event.projectStatus && event.financialStatus) {
      -
    }

    @if (event.financialStatus) {
      {{ event.financialStatus }}
    }
  </div>
}

@if (event.TechnicianNames.length) {
  <div class="eventTechnicians">
    {{ event.TechnicianNames }}
  </div>
}

<div class="eventSubject">{{ event.Subject }}</div>
